import { rufe } from './client';

/** Die sechzehn Laender als Kuerzel (FRS-08) — dieselbe Liste wie am Server. */
export const BUNDESLAENDER: Readonly<Record<string, string>> = {
  BW: 'Baden-Württemberg', BY: 'Bayern', BE: 'Berlin', BB: 'Brandenburg', HB: 'Bremen',
  HH: 'Hamburg', HE: 'Hessen', MV: 'Mecklenburg-Vorpommern', NI: 'Niedersachsen',
  NW: 'Nordrhein-Westfalen', RP: 'Rheinland-Pfalz', SL: 'Saarland', SN: 'Sachsen',
  ST: 'Sachsen-Anhalt', SH: 'Schleswig-Holstein', TH: 'Thüringen',
};

/** Ein Standort, wie die Pflege ihn sieht (RES-01, TAG-01; Auftrag #12). */
export type Standort = {
  readonly kennung: string;
  readonly bezeichnung: string;
  readonly strasse: string | null;
  readonly plz: string | null;
  readonly ort: string | null;
  readonly bundesland: string;
  readonly bemerkung: string | null;
  readonly buchbar: boolean;
  readonly aktiv: boolean;
  readonly hauptstandort: boolean;
  readonly blocklaengeMinuten: number;
  readonly tagesbeginn: string;
  readonly tagesende: string;
  readonly terminrasterMinuten: number;
  /** SUP-51: der Google-Standort, dessen Rezensionen abgeglichen werden. */
  readonly googleStandort: string | null;
  readonly geaendertAm: string;
};

/** Was sich aendern laesst. Die Kennung gehoert nicht dazu. */
export type Standortfelder = {
  readonly bezeichnung: string;
  readonly strasse: string | null;
  readonly plz: string | null;
  readonly ort: string | null;
  readonly bundesland: string;
  readonly bemerkung: string | null;
  readonly buchbar: boolean;
  readonly aktiv: boolean;
  /** SUP-51: nur beim Ändern — die Anlage kennt das Feld nicht. */
  readonly googleStandort?: string | null;
};

export async function standorte(): Promise<readonly Standort[]> {
  return (await rufe<{ readonly standorte: readonly Standort[] }>('/standorte')).standorte;
}

export async function standortAendern(kennung: string, felder: Standortfelder): Promise<Standort> {
  return rufe<Standort>(`/standorte/${encodeURIComponent(kennung)}`, { verfahren: 'PATCH', rumpf: felder });
}

export async function standortAnlegen(felder: Standortfelder & { readonly kennung: string }): Promise<Standort> {
  return rufe<Standort>('/standorte', { verfahren: 'POST', rumpf: felder });
}
